import React, { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import api from '../login/axiosInstance';
import { errorMessage } from '../login/Login';
import { useAuth } from '../login/AuthContext';
import { appColors, appNames } from './config';

export default function AccountAccess({ user }) {
  const { username } = useAuth(), cache = useQueryClient();
  const [form, setForm] = useState(() => ({ role: user.role || 'USER', enabled: user.enabled !== false,
    apps: Object.fromEntries(Object.keys(appNames).map(key => [key, user.apps?.[key] !== false])) }));
  const [busy, setBusy] = useState(false), [error, setError] = useState(''), [saved, setSaved] = useState(false);
  const self = user.username.toLowerCase() === username?.toLowerCase();
  async function save(event) {
    event.preventDefault(); setBusy(true); setError(''); setSaved(false);
    try {
      await api.put(`/api/admin/accounts/${user.id}/access`, form);
      await Promise.all(['admin-accounts', 'account', 'tools'].map(key => cache.invalidateQueries({ queryKey: [key] })));
      setSaved(true);
    } catch (failure) { setError(errorMessage(failure)); } finally { setBusy(false); }
  }
  return <details className="access-control"><summary>Manage access · {user.enabled === false ? 'Account disabled' : 'Account enabled'}</summary>
    <form onSubmit={save} aria-label={`Access for ${user.username}`}><fieldset disabled={busy}>
      <label>Role<select aria-label={`Role for ${user.username}`} disabled={self} value={form.role} onChange={e => { setForm({ ...form, role: e.target.value }); setSaved(false); }}><option value="USER">User</option><option value="ADMIN">Admin</option></select></label>
      <label className="access-switch"><input type="checkbox" disabled={self} checked={form.enabled} onChange={e => { setForm({ ...form, enabled: e.target.checked }); setSaved(false); }}/>Account enabled</label>
      <div className="app-access-options">{Object.keys(appNames).map(app => <label className="access-switch" key={app} style={{ '--app-color': appColors[app] }}><input type="checkbox" checked={form.apps[app]} onChange={e => { setForm({ ...form, apps: { ...form.apps, [app]: e.target.checked } }); setSaved(false); }}/><i/>{appNames[app]}</label>)}</div>
      <button className="button secondary" type="submit">{busy ? 'Saving…' : 'Save access'}</button>
    </fieldset>{self && <small>You can change your app access. Your own admin role and account stay enabled.</small>}
    {saved && <p role="status">Access saved.</p>}{error && <p role="alert">{error}</p>}</form>
  </details>;
}
